import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-familia-section border-t border-white/10 py-10 md:py-16 px-4 md:px-6" data-id="element-95">
      <div className="max-w-5xl mx-auto w-[92%] md:w-full" data-id="element-96">
        <div className="flex flex-col items-center text-center mb-8" data-id="element-97">
          <div className="flex flex-col mb-4" data-id="element-98">
            <span className="text-white font-display text-xl sm:text-2xl font-extrabold leading-tight tracking-tight" data-id="element-99">
              MUNDIAL EN EL AULA 360™
            </span>
            <span className="text-familia-cyan text-[10px] sm:text-xs font-bold tracking-widest uppercase mt-1" data-id="element-100">
              Mega Pack Primaria 2026
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 text-[11px] sm:text-xs text-familia-gray font-medium mb-6" data-id="element-101">
            <span data-id="element-102">✅ De 1.º a 7.º grado</span>
            <span data-id="element-103">✅ Proyecto interdisciplinario</span>
            <span data-id="element-104">✅ Cuatro bonos</span>
            <span data-id="element-105">✅ Acceso inmediato</span>
          </div>

          <div className="flex justify-center text-xs text-white font-bold" data-id="element-106">
            <a href="mailto:soporte@mundialenelaula.com" className="hover:text-familia-cyan transition-colors" data-id="element-107">
              Email: soporte@mundialenelaula.com
            </a>
          </div>
        </div>

        <div className="w-full h-px bg-white/10 mb-8" data-id="element-108" />

        <div className="max-w-3xl mx-auto space-y-4 text-center text-[10px] sm:text-xs text-familia-gray leading-relaxed font-medium" data-id="element-109">
          <p data-id="element-110">
            © 2026 Mundial en el Aula 360™. Todos los derechos reservados.
          </p>
          <p className="opacity-70" data-id="element-111">
            Mundial en el Aula 360™ es un producto educativo digital
            independiente. No está afiliado, patrocinado ni respaldado por FIFA
            ni por los organizadores oficiales del torneo.
          </p>
        </div>
      </div>
    </footer>;
};